import { createRoutine } from 'redux-saga-routines'

export const SET = 'LOADING/SET'
export const CONTENT = createRoutine('LOADING/CONTENT')
export const SET_LOADING = createRoutine('LOADING/SET_LOADING')
